import React, { useCallback, useContext, useEffect } from 'react';
import { useInterpret, useSelector } from '@xstate/react';
import { useParams } from 'react-router-dom';

import { DataAccessContext } from '@chargify/data-access';
import {
  paymentGatewaySelectors,
  paymentProfiles,
  subscriptionsSelectors,
} from '../machines';
import { PaymentProfilesContext } from '../contexts';
import { useServices } from '../hooks';

type Props = {
  children: React.ReactNode;
};

export const PaymentProfilesProvider = ({ children }: Props) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { paymentGatewayService } = useServices();
  const { subscriptionsService } = useServices();
  const { catalogId, subscriptionId } = useParams();

  const { subscription } = useSelector(
    subscriptionsService,
    useCallback(
      subscriptionsSelectors.getSubscriptionById(
        Number(catalogId),
        Number(subscriptionId)
      ),
      []
    )
  );
  const vaultCurrencies = useSelector(
    paymentGatewayService,
    paymentGatewaySelectors.getVaultCurrencies
  );
  const paymentProfilesService = useInterpret(paymentProfiles, {
    context: {
      vaultCurrencies,
      subscriptionCurrency: subscription.currency,
      subscriptionPaymentProfileId: subscription.billing.paymentProfileId,
    },
    services: {
      getPaymentProfiles: () => {
        return dataAccess.getPaymentProfiles();
      },
    },
  });

  useEffect(() => {
    paymentProfilesService.send({ type: 'INITIALIZE' });
  }, [paymentProfilesService]);

  return (
    <PaymentProfilesContext.Provider
      value={{
        paymentProfilesService,
        subscriptionCurrency: subscription.currency,
      }}
    >
      {children}
    </PaymentProfilesContext.Provider>
  );
};
